// Convenience limits within one browser tab, not a security or billing boundary.
// Only request timestamps are stored; never addresses, predictions or API keys.
export function createAddressSearchGuard({ storage, now = () => Date.now(), limit = 30, windowMs = 60000 } = {}) {
  const key = 'carrylug.address-search.v1';
  let state = { requests: [], blockedUntil: 0 };
  if (storage === undefined) {
    try { storage = window.sessionStorage; } catch (_) { storage = null; }
  }
  try {
    const saved = JSON.parse(storage && storage.getItem(key));
    if (saved && Array.isArray(saved.requests) && saved.requests.every(Number.isFinite) && Number.isFinite(saved.blockedUntil)) {
      state = { requests: saved.requests.slice(-limit), blockedUntil: saved.blockedUntil };
    }
  } catch (_) { /* Storage may be unavailable or contain an old invalid value. */ }

  function save() {
    try { if (storage) storage.setItem(key, JSON.stringify(state)); } catch (_) { /* Keep the in-memory guard. */ }
  }

  return {
    consume() {
      const time = now();
      state.requests = state.requests.filter(value => value > time - windowMs && value <= time);
      if (time < state.blockedUntil) return { allowed: false, retryAfter: Math.ceil((state.blockedUntil - time) / 1000) };
      if (state.requests.length >= limit) {
        state.blockedUntil = time + windowMs;
        save();
        return { allowed: false, retryAfter: Math.ceil(windowMs / 1000) };
      }
      state.blockedUntil = 0;
      state.requests.push(time);
      save();
      return { allowed: true, retryAfter: 0 };
    }
  };
}
